import { MEMBERSHIP_TYPES_ENUM } from './enums'

export const PLAY_STYLES_ARRAY = ['low-contact', 'high-contact', 'fast', 'puppy play', 'other']
export const PLAYGROUP_TYPE_SIZES_ARRAY = ['smallest', 'medium', 'largest']
export const PLAYGROUP_TYPE_BEST_FIT_SIZES_ARRAY = ['xs', 's', 'm', 'l', 'xl', 'all']
export const PLAYGROUP_TYPE_AGES = ['all', 'young', 'adult', 'senior']

export const DEFAULT_EMPTY_VALUE = '---'
export const GROOMING_DEFAULT_EMPTY_VALUE = '- -'

export const BAR_MEMBERSHIP_TYPES = [MEMBERSHIP_TYPES_ENUM.bar_annual, MEMBERSHIP_TYPES_ENUM.bar_monthly]
export const VIP_MEMBERSHIP_TYPES = [
	MEMBERSHIP_TYPES_ENUM.vip_annual,
	MEMBERSHIP_TYPES_ENUM.vip_monthly,
	MEMBERSHIP_TYPES_ENUM.vip_trial,
	MEMBERSHIP_TYPES_ENUM.founding
]
export const BAR_VIP_MEMBERSHIP_TYPES = [...BAR_MEMBERSHIP_TYPES, ...VIP_MEMBERSHIP_TYPES]

export const isVipMembershipType = (type) =>
	type === MEMBERSHIP_TYPES_ENUM.founding || !!type?.includes('vip')

export const NON_BREAKING_SPACE = '\u00A0'

export const BAD_STRIPE_CHARGE_STATUSES = ['failed', 'error']

export const APP_OPTIONS = {
	'TM Pet Care': 'team',
	'Admins & TM Dog Walking': 'admin'
}

export const GROOMING_LEVELS = {
	NoTrim: 'No Trim',
	Trim: 'Trim',
	FullCut: 'Full Cut'
}

export const GROOMING_SERVICE_TYPES = {
	bath: 'bath',
	cleanup: 'cleanup',
	trim: 'trim',
	haircut: 'haircut',
	nail_trim: 'nail_trim',
	addon_only: 'addon_only'
}

export const GROOMING_SERVICE_LABELS = {
	[GROOMING_SERVICE_TYPES.bath]: 'Bath & Towel Dry',
	[GROOMING_SERVICE_TYPES.cleanup]: 'Bath & Blow Out',
	[GROOMING_SERVICE_TYPES.trim]: 'Touch Up',
	[GROOMING_SERVICE_TYPES.haircut]: 'Cut & Style',
	[GROOMING_SERVICE_TYPES.nail_trim]: 'Nail Trim',
	[GROOMING_SERVICE_TYPES.addon_only]: 'Enrichment Only'
}

export const STATIC_GROOMING_SERVICES = [
	{
		value: GROOMING_SERVICE_TYPES.haircut,
		label: GROOMING_SERVICE_LABELS[GROOMING_SERVICE_TYPES.haircut]
	},
	{
		value: GROOMING_SERVICE_TYPES.cleanup,
		label: GROOMING_SERVICE_LABELS[GROOMING_SERVICE_TYPES.cleanup]
	},
	{ value: GROOMING_SERVICE_TYPES.trim, label: GROOMING_SERVICE_LABELS[GROOMING_SERVICE_TYPES.trim] },
	{ value: GROOMING_SERVICE_TYPES.bath, label: GROOMING_SERVICE_LABELS[GROOMING_SERVICE_TYPES.bath] }
]

export const VISIT_TYPES = {
	Grooming: 'grooming',
	Daycare: 'daycare',
	Boarding: 'boarding',
	CompatibilitySession: 'compatibility_session',
	AddonOnly: 'addon_only',
	BathingHygiene: 'bathing_hygiene'
}

// boarding_options[].stay_type values; not the same thing as LINE_ITEM_TYPES (invoice line item types)
export const STAY_TYPES = {
	Standard: 'standard',
	SignatureStay: 'comfort_plus',
	SignaturePlay: 'signature_play'
}

export const APPOINTMENT_TYPE_FILTERS = {
	WelcomeDay: 'welcome_day',
	SignatureStay: 'signature_stay',
	SignaturePlay: 'signature_play'
}

export const VISIT_TYPE_DISPLAY_NAMES = {
	[VISIT_TYPES.AddonOnly]: 'Enrichment Only',
	[VISIT_TYPES.CompatibilitySession]: 'Welcome Day',
	[VISIT_TYPES.Grooming]: 'Grooming',
	[VISIT_TYPES.Daycare]: 'Daycare',
	[VISIT_TYPES.Boarding]: 'Boarding'
}

export const DOG_BREEDS = {
	affenpinscher: 'Affenpinscher',
	afghan_hound: 'Afghan Hound',
	airedale_terrier: 'Airedale Terrier',
	akita: 'Akita',
	alaskan_malamute: 'Alaskan Malamute',
	american_english_coonhound: 'American English Coonhound',
	american_eskimo_dog: 'American Eskimo Dog',
	american_foxhound: 'American Foxhound',
	american_hairless_terrier: 'American Hairless Terrier',
	american_staffordshire_terrier: 'American Staffordshire Terrier',
	american_water_spaniel: 'American Water Spaniel',
	anatolian_shepherd_dog: 'Anatolian Shepherd Dog',
	australian_cattle_dog: 'Australian Cattle Dog',
	australian_shepherd: 'Australian Shepherd',
	australian_terrier: 'Australian Terrier',
	azawakh: 'Azawakh',
	basenji: 'Basenji',
	basset_hound: 'Basset Hound',
	beagle: 'Beagle',
	bearded_collie: 'Bearded Collie',
	beauceron: 'Beauceron',
	bedlington_terrier: 'Bedlington Terrier',
	belgian_laekenois: 'Belgian Laekenois',
	belgian_malinois: 'Belgian Malinois',
	belgian_sheepdog: 'Belgian Sheepdog',
	belgian_tervuren: 'Belgian Tervuren',
	bergamasco: 'Bergamasco',
	berger_picard: 'Berger Picard',
	bernese_mountain_dog: 'Bernese Mountain Dog',
	bichon_frise: 'Bichon Frise',
	black_and_tan_coonhound: 'Black and Tan Coonhound',
	black_russian_terrier: 'Black Russian Terrier',
	bloodhound: 'Bloodhound',
	bluetick_coonhound: 'Bluetick Coonhound',
	boerboel: 'Boerboel',
	border_collie: 'Border Collie',
	border_terrier: 'Border Terrier',
	borzoi: 'Borzoi',
	boston_terrier: 'Boston Terrier',
	bouvier_des_flandres: 'Bouvier des Flandres',
	boxer: 'Boxer',
	boykin_spaniel: 'Boykin Spaniel',
	briard: 'Briard',
	brittany: 'Brittany',
	brussels_griffon: 'Brussels Griffon',
	bull_terrier: 'Bull Terrier',
	bulldog: 'Bulldog',
	bullmastiff: 'Bullmastiff',
	cairn_terrier: 'Cairn Terrier',
	canaan_dog: 'Canaan Dog',
	cane_corso: 'Cane Corso',
	cavalier_king_charles_spaniel: 'Cavalier King Charles Spaniel',
	cesky_terrier: 'Cesky Terrier',
	chesapeake_bay_retriever: 'Chesapeake Bay Retriever',
	chihuahua: 'Chihuahua',
	chinese_crested: 'Chinese Crested',
	chinese_shar_pei: 'Chinese Shar-Pei',
	chinook: 'Chinook',
	chow_chow: 'Chow Chow',
	cirneco_dell_etna: 'Cirneco Dell’Etna',
	clumber_spaniel: 'Clumber Spaniel',
	cocker_spaniel: 'Cocker Spaniel',
	collie: 'Collie',
	corgi: 'Corgi',
	coton_de_tulear: 'Coton De Tulear',
	curly_coated_retriever: 'Curly-Coated Retriever',
	dachshund: 'Dachshund',
	dalmatian: 'Dalmatian',
	dandie_dinmont_terrier: 'Dandie Dinmont Terrier',
	doberman_pinscher: 'Doberman Pinscher',
	dogo_argentino: 'Dogo Argentino',
	dogue_de_bordeaux: 'Dogue de Bordeaux',
	english_cocker_spaniel: 'English Cocker Spaniel',
	english_foxhound: 'English Foxhound',
	english_setter: 'English Setter',
	english_springer_spaniel: 'English Springer Spaniel',
	english_toy_spaniel: 'English Toy Spaniel',
	entlebucher_mountain_dog: 'Entlebucher Moutain Dog',
	field_spaniel: 'Field Spaniel',
	finish_spitz: 'Finish Spitz',
	finnish_lapphund: 'Finnish Lapphund',
	flat_coated_retriever: 'Flat-Coated Retriever',
	french_bulldog: 'French Bulldog',
	german_pinscher: 'German Pinscher',
	german_shepherd: 'German Shepherd',
	german_shorthaired_pointer: 'German Shorthaired Pointer',
	german_wirehaired_pointer: 'German Wirehaired Pointer',
	giant_schnauzer: 'Giant Schnauzer',
	glen_of_imaal_terrier: 'Glen of Imaal Terrier',
	golden_retriever: 'Golden Retriever',
	goldendoodle: 'Goldendoodle',
	gordon_setter: 'Gordon Setter',
	grand_basset_griffon_vendeen: 'Grand Basset Griffon Vendeen',
	great_dane: 'Great Dane',
	great_pyrenees: 'Great Pyrenees',
	greater_swiss_mountain_dog: 'Greater Swiss Mountain Dog',
	greyhound: 'Greyhound',
	harrier: 'Harrier',
	havanese: 'Havanese',
	ibizan_hound: 'Ibizan Hound',
	icelandic_sheepdog: 'Icelandic Sheepdog',
	irish_red_and_white_setter: 'Irish Red and White Setter',
	irish_setter: 'Irish Setter',
	irish_terrier: 'Irish Terrier',
	irish_water_spaniel: 'Irish Water Spaniel',
	irish_wolfhound: 'Irish Wolfhound',
	italian_greyhound: 'Italian Greyhound',
	jack_russell_terrier: 'Jack Russell Terrier',
	japanese_chin: 'Japanese Chin',
	keeshond: 'Keeshond',
	kerry_blue_terrier: 'Kerry Blue Terrier',
	komondor: 'Komondor',
	kuvasz: 'Kuvasz',
	lab_mix: 'Lab Mix',
	labradoodle: 'Labradoodle',
	labrador_retriever: 'Labrador Retriever',
	lagotto_romagnolo: 'Lagotto Romagnolo',
	lakeland_terrier: 'Lakeland Terrier',
	leonberger: 'Leonberger',
	lhasa_apso: 'Lhasa Apso',
	lowchen: 'Lowchen',
	maltese: 'Maltese',
	manchester_terrier: 'Manchester Terrier',
	mastiff: 'Mastiff',
	minature_american_shepherd: 'Miniature American Shepherd',
	minature_bull_terrier: 'Miniature Bull Terrier',
	minature_pinscher: 'Miniature Pinscher',
	miniature_poodle: 'Miniature Poodle',
	miniature_schnauzer: 'Miniature Schnauzer',
	mixed: 'Mixed',
	neapolitan_mastiff: 'Neapolitan Mastiff',
	nederlandse_kooikerhondje: 'Nederlandse Kooikerhondje',
	newfoundland: 'Newfoundland',
	norfolk_terrier: 'Norfolk Terrier',
	norrbottenspets: 'Norrbottenspets',
	norwegian_buhund: 'Norwegian Buhund',
	norwegian_elkhound: 'Norwegian Elkhound',
	norwegian_lundhund: 'Norwegian Lundhund',
	norwich_terrier: 'Norwich Terrier',
	nova_scotia_duck_tolling_retriever: 'Nova Scotia Duck Tolling Retriever',
	old_english_sheepdog: 'Old English Sheepdog',
	other: 'Other',
	otterhound: 'Otterhound',
	papillon: 'Papillon',
	pekingese: 'Pekingese',
	peruvian_inca_orchid: 'Peruvian Inca Orchid',
	petit_basset_griffon_vendeen: 'Petit Basset Griffon Vendeen',
	pharaoh_hound: 'Pharaoh Hound',
	pitbull_mix: 'Pitbull Mix',
	pitbull_terrier: 'Pitbull Terrier',
	plott: 'Plott',
	pointer: 'Pointer',
	polish_lowland_sheepdog: 'Polish Lowland Sheepdog',
	pomeranian: 'Pomeranian',
	poodle_mix: 'Poodle Mix',
	portuguese_podengo: 'Portuguese Podengo',
	portuguese_podengo_pequeno: 'Portuguese Podengo Pequeno',
	portuguese_water_dog: 'Portuguese Water Dog',
	pug: 'Pug',
	puli: 'Puli',
	pumi: 'Pumi',
	pyrenean_sheepdog: 'Pyrenean Sheepdog',
	rat_terrier: 'Rat Terrier',
	redbone_coonhound: 'Redbone Coonhound',
	rhodesian_ridgeback: 'Rhodesian Ridgeback',
	rottweiler: 'Rottweiler',
	saluki: 'Saluki',
	samoyed: 'Samoyed',
	schipperke: 'Schipperke',
	scottish_deerhound: 'Scottish Deerhound',
	scottish_terrier: 'Scottish Terrier',
	sealyham_terrier: 'Sealyham Terrier',
	shetland_sheepdog: 'Shetland Sheepdog',
	shiba_inu: 'Shiba Inu',
	shih_tzu: 'Shih Tzu',
	siberian_husky: 'Siberian Husky',
	silky_terrier: 'Silky Terrier',
	skye_terrier: 'Skye Terrier',
	sloughi: 'Sloughi',
	smooth_fox_terrier: 'Smooth Fox Terrier',
	spanish_water_dog: 'Spanish Water Dog',
	spinone_italiano: 'Spinone Italiano',
	st_bernard: 'St. Bernard',
	staffordshire_bull_terrier: 'Staffordshire Bull Terrier',
	standard_poodle: 'Standard Poodle',
	standard_schnauzer: 'Standard Schnauzer',
	sussex_spaniel: 'Sussex Spaniel',
	swedish_vallhund: 'Swedish Vallhund',
	tibetan_mastiff: 'Tibetan Mastiff',
	tibetan_spaniel: 'Tibetan Spaniel',
	tibetan_terrier: 'Tibetan Terrier',
	toy_fox_terrier: 'Toy Fox Terrier',
	toy_poodle: 'Toy Poodle',
	treeing_walker_coonhound: 'Treeing Walker Coonhound',
	vizsla: 'Vizsla',
	weimaraner: 'Weimaraner',
	welsh_springer_spaniel: 'Welsh Springer Spaniel',
	welsh_terrier: 'Welsh Terrier',
	west_highland_white_terrier: 'West Highland White Terrier',
	wheaten_terrier: 'Wheaten Terrier',
	whippet: 'Whippet',
	wire_fox_terrier: 'Wire Fox Terrier',
	wirehaired_pointing_griffon: 'Wirehaired Pointing Griffon',
	wirehaired_vizsla: 'Wirehaired Vizsla',
	xoloitzcuintli: 'Xoloitzcuintli',
	yorkshire_terrier: 'Yorkshire Terrier'
}

export const CUTOFFS = {
	0: 'the day of',
	1: 'one day before',
	2: 'two days before'
}

export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD'

export const GROOMING = 'grooming'
export const DAYCARE = 'daycare'
export const BOARDING = 'boarding'
export const ADDON_ONLY = 'addon_only'
export const BAR_PARK = 'bar_park'
export const HOME_SERVICES = 'home_services'
export const CREDITS = 'credits'
export const COMPATIBILITY_SESSION = 'compatibility_session'
export const TRAINING = 'training'
export const TRAINING_CLASS = 'training_class'
export const FACILITY_VISIT_RELATED_TRAINING = 'facility_visit_related_training' // Play & Study
export const DEFAULT_FACILITY_CONTACT_PHONE = '704-343-6658'
export const PERCENT = 'percent'
export const CENTS = 'cents'
export const MEAL = 'meal'
export const MEDICATION = 'medication'
export const PETCARE = 'petcare'
export const DAYPASS = 'daypass'
export const FEE_VALUE_UNITS = {
	[PERCENT]: 'Percentage (%)',
	[CENTS]: 'U.S. Dollars ($)'
}

export const RENEWAL_LIMITS = {
	0: 0,
	1: 1,
	2: 2,
	3: 3,
	4: 4,
	5: 5,
	6: 6,
	7: 7,
	8: 8,
	9: 9,
	10: 10,
	11: 11,
	12: 12
}

export const DIALOG_EDIT_MODES = {
	New: 'new',
	Edit: 'edit',
	ViewOnly: 'view_only'
}

export const ADDON_REVENUE_TYPES = {
	petcare: 'Petcare',
	[GROOMING]: 'Grooming',
	[TRAINING]: 'Training'
}

export const STAFF_NOTE_STATUS = {
	Open: 'Open',
	InProgress: 'In Progress',
	Closed: 'Closed'
}

export const STAFF_NOTE_TYPES = {
	General: 'General',
	Health: 'Health',
	Meal: 'Meal',
	Behavior: 'Behavior',
	Kenneling: 'Kenneling',
	Incident: 'Incident'
}

export const AUTOMATED_ALERTS = 'Automated Alerts'

export const EMOJIS = {
	pickup: '👋',
	dropoff: '🛬',
	medication: '💊',
	welcome_day: '🗓️'
}

// Maximum number of simultaneously active promos that can be surfaced in the client app.
export const CLIENT_APP_PROMO_LIMIT = 20
